export const MUTATION_KEYS = {
    send_billing_info: 'send-billing-info',
    edit_billing_info: 'edit-billing-info'
}

export const QUERY_KEYS = {
    billing_info: 'billing-info'
}
